module.exports = __webpack_public_path__ + "img/fill_main.acaa9e47.png";